import { useNavigate } from "react-router-dom";
import { ChevronRight, X } from "lucide-react";
import { useCart } from "@/lib/cart";

export default function CartBar() {
  const { items, admin, clear } = useCart();
  const navigate = useNavigate();
  if (!items.length) return null;
  const noun = admin.length ? "item" : "course";
  // Courses always check out through the application form; a services-only
  // cart goes to the lightweight checkout page.
  const target = items.some((c) => typeof c === "string") ? "/admissions?checkout=1" : "/checkout";
  return (
    <div className="fixed inset-x-0 bottom-5 z-40 flex justify-center px-4" data-testid="cart-bar">
      <div className="flex items-center gap-3 rounded-full bg-ink py-2.5 pl-6 pr-2.5 text-ivory shadow-2xl shadow-ink/40">
        <span className="text-sm font-semibold">
          <span className="font-mono text-brandlight">{items.length}</span> {noun}{items.length > 1 ? "s" : ""} in cart
        </span>
        <button
          type="button"
          onClick={() => navigate(target)}
          data-testid="cart-checkout-btn"
          className="btn-accent !px-5 !py-2"
        >
          Checkout <ChevronRight className="h-4 w-4" />
        </button>
        <button
          type="button"
          onClick={() => clear()}
          data-testid="cart-clear-btn"
          aria-label="Clear cart"
          className="flex h-8 w-8 items-center justify-center rounded-full text-ivory/50 transition-colors hover:bg-ivory/10 hover:text-ivory"
        >
          <X className="h-4 w-4" />
        </button>
      </div>
    </div>
  );
}
